import { FC } from 'react';

import FlowrLogo from '@/assets/logos/logo_flowr.svg?react';
import {
  BrandLogoProps,
  DEFAULT_BRAND_LOGO_HEIGHT,
} from '@/components/shared/logos/props';

const BrandLogoFlowr: FC<BrandLogoProps> = ({
  themeAware = true,
  primaryColor,
  borderlessScale = false,
  height = DEFAULT_BRAND_LOGO_HEIGHT,
  width = 90,
  ...other
}) => {
  const additionalProps: any = {};

  return (
    <FlowrLogo
      {...other}
      height={height}
      style={{
        ...other.style,
        width: width,
      }}
      {...additionalProps}
    />
  );
};

export default BrandLogoFlowr;
